import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import { useNavigate } from "react-router-dom";
import HeroBanner2 from "../components/HeroBanner2";
import Loader from "../components/Loader";
export default function Shop() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [subCategoryData, setsubCategoryData] = useState([]);
    const [sizeData, setSizeData] = useState([]);
    const [ageData, setAgeData] = useState([]);
    const [productData, setProductData] = useState([]);
    const [selectedSize, setSelectedSize] = useState(null);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(null);
    const [selectedAgeId, setSelectedAgeId] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
        fetchCategoryData();
        fetchAllProductData();
    }, []);
    useEffect(() => {
        if (dataSource?.length > 0) {
            const storedId = localStorage.getItem("selectedCategoryId");
            if (storedId) {
                setSelectedId(String(storedId));
            }
        }
    }, [dataSource]);
    const fetchCategoryData = async () => {
        setLoading(true);
        try {
            const [cat, sub, size, age] = await Promise.all([
                makeRequest("get", webEndPoint + "maincategories"),
                makeRequest("get", webEndPoint + "subcategories/bycategory/" + localStorage.getItem("selectedCategoryId")),
                makeRequest("get", webEndPoint + "sizes"),
                makeRequest("get", webEndPoint + "ages"),
            ]);
            setDataSource(cat?.data || []);
            setsubCategoryData(sub?.data || []);
            setSizeData(size?.data || []);
            setAgeData(age?.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchAllProductData = async (newSubCategoryId, newAgeId) => {
        setLoading(true);
        try {
            const params = new URLSearchParams({
                main_category_id: localStorage.getItem("selectedCategoryId"),
                sub_category_id: newSubCategoryId || "",
                age_id: newAgeId || ""
            });
            const url = `${webEndPoint}product/filter?${params.toString()}`;
            const response = await makeRequest("get", url);
            if (response) {
                setProductData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleCategoryClick = (id) => {
        navigate(`/shop/productdetails/${id}`);
    };
    return (
        <div>
            <Loader loading={loading} />
            <Header />
            <HeroBanner2 />
            <div className="category-containers">
                {dataSource?.map((item, index) => (
                    <div key={index}
                        className={`category-card ${String(selectedId) === String(item.rfId) ? "active" : ""}`}
                        onClick={() => {
                            const isSame = String(selectedId) === String(item.rfId);
                            const newId = isSame ? null : String(item.rfId);
                            setSelectedId(newId);
                            if (newId) {
                                localStorage.setItem("selectedCategoryId", newId);
                                fetchCategoryData();
                                fetchAllProductData();
                            } else {
                                localStorage.removeItem("selectedCategoryId");
                            }
                        }}>
                        <img src={item?.image_url} alt={item?.maincategory_name} />
                        <span>{item.maincategory_name}</span>
                    </div>
                ))}
            </div>
            <div className="shop-layout">
                <aside className="filter">
                    <h3>Filters</h3>
                    <div className="filter-group">
                        <p>Sub Category</p>
                        {subCategoryData?.map((item, index) => (
                            <div key={index}>
                                <label className="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={selectedSubCategoryId === item.subcategory_id}
                                        onChange={() => {
                                            const isSame = selectedSubCategoryId === item.subcategory_id;
                                            const newId = isSame ? null : item.subcategory_id;
                                            setSelectedSubCategoryId(newId);
                                             fetchAllProductData(newId, selectedAgeId);
                                        }}
                                    />
                                    <span className="checkmark"></span>
                                    {item.subcategory_name}
                                </label>
                            </div>
                        ))}
                    </div>
                    <div className="filter-group">
                        <p>Age</p>
                        <select
                            className="form-select"
                            value={selectedAgeId}
                            onChange={(e) => {
                                const ageId = e.target.value;
                                setSelectedAgeId(ageId);
                                fetchAllProductData( selectedSubCategoryId, ageId);
                            }}>
                            <option value="">Select Age</option>
                            {ageData?.map((item) => (
                                <option key={item.rfId} value={item.rfId}>
                                    {item.age_name}
                                </option>
                            ))}
                        </select>
                    </div>
                </aside>
                <section className="product">
                    {productData?.map((p) => (
                        <div key={p.id} className="prod-card" onClick={() => handleCategoryClick(p?.rfId)} style={{ cursor: "pointer" }}>
                            <img src={p?.image_url} alt={p?.product_name} />
                            <h4>{p?.product_name}</h4>
                            <div className="rating">⭐⭐⭐⭐⭐</div>
                        </div>
                    ))}
                </section>
            </div>
            <Footer />
        </div>
    )
}
